module.exports = __webpack_public_path__ + "static/assets/24280045e9bd9d427721e4482c143e6e.svg";